/* eslint-disable no-useless-escape */
export function validateEmail(email) {
  // eslint-disable-next-line no-useless-escape
  const reg = new RegExp(
    /^[A-Za-z0-9_\-\.]+@[A-Za-z0-9_\-\.]{2,}\.[A-Za-z0-9]{2,}(\.[A-Za-z0-9])?/
  );
  return reg.test(email);
}

export function validateCpf(cpfToValidate) {
  let sum = 0;
  let residue;
  const cpf = cpfToValidate.replace(/\D/g, '');
  if (cpf === '00000000000') {
    return false;
  }

  for (let i = 1; i <= 9; i += 1) {
    sum += parseInt(cpf.substring(i - 1, i), 10) * (11 - i);
  }
  residue = (sum * 10) % 11;

  if (residue === 10 || residue === 11) {
    residue = 0;
  }

  if (residue !== parseInt(cpf.substring(9, 10), 10)) {
    return false;
  }

  sum = 0;

  for (let i = 1; i <= 10; i += 1) {
    sum += parseInt(cpf.substring(i - 1, i), 10) * (12 - i);
  }

  residue = (sum * 10) % 11;

  if (residue === 10 || residue === 11) {
    residue = 0;
  }
  if (residue !== parseInt(cpf.substring(10, 11), 10)) {
    return false;
  }
  return true;
}
